export const h = {
	quantity: "в наличии",
	brand: "марка",
	sku: "SKU",
	model: "модель",
	addCart: "добавить в корзину",
	buyNow: "Купи сейчас",
	productDetail: "информация о продукте",
	attribute: "Attribute",
	quantityExits: "В наличии",
	quantityNone: "распродано",

	// 账单页面
	email: "Электронная почта",
	errorEmail: "Пожалуйста, введите корректный email",
	contact: 'Контактные данные',
	sippingAddress: 'Адрес доставки',
	name: "Имя",
	nameError: "Пожалуйста, укажите имя",
	address1: "Адрес 1",
	address1Error: "Пожалуйста, укажите адрес 1",
	address2: "Адрес 2",
	emailCode: "Почтовый индекс",
	phone: "Номер телефона",
	city: "Город",
	cityError: "Пожалуйста, укажите город",
	country: "Страна",
	countryError: "Пожалуйста, укажите страну",
	province: "Область/Регион",
	provinceError: "Пожалуйста, укажите область/регион",
	payWay: "Способ оплаты",
	sendWay: "Способ доставки",
	loginText: "Войти / Регистрация",
	cartNum: "Всего в корзине",
	orderRemarks: "Комментарий к заказу",
	discountCode: "Введите промокод",
	apply: "Применить",
	submitOrder: "Оформить заказ",
	classify: "Категория",
	price: "Цена",
	allNum: "Общее количество",
	defaultTit: "По умолчанию",
	salesLowToHigh: "Продажи (низкие → высокие)",
	salesHighToLow: "Продажи (высокие → низкие)",
	nameAtoZ: "Имя (A → Z)",
	nameZtoA: "Имя (Z → A)",
	priceLowtoHeight: "Цена (низкая → высокая)",
	priceHeighttoLow: "Цена (высокая → низкая)",
	selectClassfiy: "Выберите категорию",
	goodCart: "Корзина",
	checkout: "Оформить заказ",
	pay: "Оплатить",
	goods: "Товар",
	num: "Количество",
	total: "Итого",
	action: "Действие",
	del: "Удалить",
	priceTotal: "Общая сумма товаров",
	all: "Все",
	selectd: "Выбрано",
	goCheckout: "Перейти к оплате",
	linkGoods: "Сопутствующие товары",
	noData: "Нет данных",
	myOrder: "Мои заказы",
	changeUserInfo: "Изменить профиль",
	changePassword: "Изменить пароль",
	myAddress: "Мои адреса",
	myWishlist: "Избранное",
	myRmas: "Послепродажное обслуживание",
	userCommission: "Комиссия пользователя",
	commissionUsers: "Отношения пользователей",
	loginOut: "Выйти",
	orderId: "Номер заказа",

	lookDetail: "Просмотреть детали",
	saleService: "Подать заявку на возврат",
	confirmReceivedGoods: "Подтвердить получение",
	goPay: "Оплатить",
	cancelOrder: "Отменить заказ",

	orderDetail: "Детали заказа",
	created_at: "Дата создания",
	status_format: "Статус заказа",
	total_format: "Сумма заказа",
	payment_method_name: 'Метод оплаты',
	shipping_method_name: 'Метод доставки',

	addressInfo: "Адресная информация",
	name: "Имя",
	address: "Адрес",
	payGoods: "Заказанные товары",

	sendCompany: "Курьерская компания",
	sendNum: "Номер накладной",
	updateTime: "Время обновления",
	memo: "Примечание",
	payOrderAddress: "Платежный адрес",
	allOrder: "Все заказы",
	waitPay: "Ожидает оплаты",
	waitSend: "Ожидает отправки",
	waitReceiving: "Ожидает получения",
	completed: "Завершен",
	confirm: "Подтвердить",
	tips: "Совет",
	cancel: 'Отмена',
	changeHeadImg: "Изменить аватар",
	uploadTit: "Загрузите JPEG или PNG изображение. Рекомендуемый размер: 300 x 300",
	imgSizeTips: "Размер изображения не должен превышать 2 МБ!",
	imgTypeTips: "Изображение должно быть в формате JPG/PNG!",
	serviceType: "Тип услуги",
	returnNum: "Количество возврата/обмена",
	isOpend: "Упаковка открыта",
	returnReason: "Причина возврата/обмена",
	yes: "Да",
	no: "Нет",
	returnGoods: "Возврат",
	exchange: "Обмен",
	repair: "Ремонт",
	reissue: "Дополнительная отправка",
	refund: "Только возврат средств",
	returnNumError: "Введите количество возврата/обмена",

	oldPassword: "Старый пароль",
	newPassword: "Новый пароль",
	confirmNewPassword: "Подтвердите новый пароль",

	wishlist: "Удалить из избранного",
	look: "Просмотр",
	opendPkg: "Упаковка открыта",
	img: "Изображение",
	afterSales: "Детали послепродажного обслуживания",

	balance: "Доступный баланс",
	waitAmount: "Сумма ожидает расчета",
	withdrawaled: "Выведено",
	withdrawal: "Вывод средств",
	allCommission: "Общая комиссия",
	startTime: "Начальное время",
	endTime: "Конечное время",
	search: "Поиск",

	rebateLevel: "Уровень кэшбэка",
	CommissionRate: "Процент комиссии",
	commission: "Комиссия",
	settlementStatus: "Статус расчета",
	time: "Время",
	WithdrawalAmount: "Сумма вывода",
	peleaseSelect: "Выберите",
	withdrawalUser: "Реквизиты вывода",
	peleaseIpt: "Введите текст",
	submitSuccess: "Успешно отправлено",
	shareLink: "Поделиться ссылкой",
	superior: "Мой прямой руководитель",
	wu: "Нет",
	subordinate: "Подчиненные",
	addTime: "Дата регистрации",
	userAccount: "Аккаунт",
	recommendationCode: "Реферальный код",
	copySuccess: "Скопировано успешно",
	subPay: "Отправить платеж",
	iptCardholder_Name: "Введите имя владельца карты",
	copy: "Копировать",

	"home": "Главная",
	"categoriesPage": "Категории",
	"brandsPage": "Бренды",
	"brandsPageList": "Товары брендов",
	"productsPage": "Товары",
	"wishlistPage": "Мои закладки",
	"accountPage": "Мои заказы",
	"cartsPage": "Корзина",
	"checkoutPage": "Оформление заказа",
	"passwordPage": "Изменить пароль",
	"editPage": "Изменить информацию",
	"addressesPage": "Изменить адрес",
	"rmasPage": "Членские отношения",
	"commissionPage": "Комиссия участника",
	"success_order_checkoutPage": "Оплата заказа",
	"page_categoriesPage": "Категории статей",
	"userloginPage": "Войти",
	"pagesPage": "Статьи",

	hotGoods: "Популярные товары",
	newGoods: "Новые товары",
	visitGoods: "Самые просматриваемые",
	allGoods: "Все товары",
	evaluation: "Отзывы",

	"first_name": "Фамилия",
	"first_nameError": "Пожалуйста, введите фамилию",
	"last_name": "Имя",
	"last_nameError": "Пожалуйста, введите имя",

	"comment": "Содержание",
	"noContent": "Пока нет комментариев",
	"author": "Автор",
	"scoreNum": "Оценка",
	"commentTit": "Комментарии",
	send: "Отправить",

	noPayWay: "Нет доступных способов оплаты",
	noTransportation: "Нет доступных способов доставки",
	"tkyouorder": "Спасибо за ваш заказ",
	  "orderDate": "Дата заказа",
	  "ordeAmount": "Сумма заказа",
	  "paymentAddress": "Платежный адрес",
	  "zipCode": "Почтовый индекс"
}